/* Products per page, site wide.

   Tony, 22 Sep 2026: "products per page needs to be site wide".

   The size is chosen on any shelf or search with the bar that
   snippets/sv-perpage.liquid draws above and below the grid. That bar stores
   the choice in this browser (sv_per). This script, loaded on every page,
   carries it everywhere else: a link to any shelf or to search gets
   ?view=perN at the moment it is clicked, and a search box gets it as a
   hidden field when it is submitted. Choosing 24 clears it.

   Nothing is rewritten in the markup, so a crawler, the canonical and a link
   someone shares all see the plain address. A visitor arriving from Google or
   an ad is never redirected: the size applies from their next click.

   Excluded on purpose: product links (/collections/x/products/y), links that
   already carry a view, the bar's own links, and the filter/sort form, which
   keeps the size itself through a hidden input on a sized page. */
(function () {
  if (window.__svPerSite) return; window.__svPerSite = 1;
  var OK = { 50: 1, 100: 1, 200: 1, 250: 1 };
  function pref() {
    try { var n = +localStorage.getItem('sv_per'); return OK[n] ? n : 0; } catch (e) { return 0; }
  }
  function listing(u) {
    if (u.origin !== location.origin) return false;
    if (/^\/search\/?$/.test(u.pathname)) return true;
    var m = u.pathname.match(/^\/collections\/([^\/]+)(?:\/([^\/]+))?\/?$/);
    return !!(m && m[2] !== 'products');
  }
  function carry(e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a || a.closest('[data-sv-perpage]')) return;
    var n = pref(); if (!n) return;
    var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (x) { return; }
    if (!listing(u) || u.searchParams.has('view')) return;
    u.searchParams.set('view', 'per' + n);
    a.setAttribute('href', u.pathname + u.search + u.hash);
  }
  ['pointerdown', 'click', 'contextmenu', 'keydown'].forEach(function (t) {
    document.addEventListener(t, carry, true);
  });
  document.addEventListener('submit', function (e) {
    var f = e.target, n = pref();
    if (!n || !f || !f.elements || !f.elements.q) return;
    if (f.querySelector('[name^="filter."],[name="sort_by"],[name="view"]')) return;
    var u; try { u = new URL(f.getAttribute('action') || location.href, location.href); } catch (x) { return; }
    if (!/^\/search\/?$/.test(u.pathname)) return;
    var i = document.createElement('input');
    i.type = 'hidden'; i.name = 'view'; i.value = 'per' + n;
    f.appendChild(i);
  }, true);
})();
